var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWinRate(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10.674,
    height: 10.203,
    fill: "rgba(0,0,0,0)",
    stroke: "#10b700",
    strokeWidth: 0.25
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-732.644 -277)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    rx: 5,
    transform: "translate(732.644 277)",
    fill: "#10b700"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(735.66 281)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 -0.69)",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.909,10.159a.77.77,0,0,0,.256.044.762.762,0,0,0,.762-.762V9.42L8.851,6.692,10.515,4.53a.762.762,0,0,0-.139-1.069.75.75,0,0,0-.249-.127L7.51,2.561,5.965.311A.79.79,0,0,0,4.857.162a.772.772,0,0,0-.149.149L3.163,2.561.547,3.334a.761.761,0,0,0-.388,1.2L1.822,6.692,1.747,9.42a.762.762,0,0,0,1.016.739l2.575-.915ZM3.306,8.35l.051-1.887A.762.762,0,0,0,3.2,5.975L2.046,4.481l1.81-.534a.762.762,0,0,0,.413-.3L5.338,2.09,6.405,3.648a.762.762,0,0,0,.413.3l1.812.534-1.151,1.5a.759.759,0,0,0-.157.488L7.37,8.35,5.592,7.717a.765.765,0,0,0-.511,0Z",
    transform: "translate(0 0)",
    fill: "#fff",
    stroke: "#10b700",
    strokeWidth: 0.25
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWinRate);
export default __webpack_public_path__ + "static/media/winRate.d07716e3760b695a1f13c5a34509f7c7.svg";
export { ForwardRef as ReactComponent };